import React from "react";
import {
  Chip, Divider,
  Fab, Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import DashboardCard from "./DashboardCard";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

const NegotiateToPayLessDetails = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));

  return (
    isMd ? (<DashboardCard title='Negotiate To Pay Less'
                           action={
                             <Fab color='secondary' size='medium'
                                  sx={{
                                    color: "#ffffff",
                                    cursor: "default",
                                    m: 0
                                  }}>
                               <TrendingDownIcon width={24}/>
                             </Fab>
                           }
      >
        <Stack spacing={5}
               direction='row'>
          <Stack direction='column'
                 display='flex'
                 spacing={1}
                 sx={{flexGrow: 1}}>
            <Stack spacing={2}
                   display='flex'
                   direction='row'
                   justifyContent='space-between'
                   alignItems='center'
                   sx={{flexGrow: 1}}>
              <Typography variant='h6'>
                Previous payment
              </Typography>
            </Stack>
            <Stack spacing={2}
                   display='flex'
                   direction='row'
                   justifyContent='space-between'
                   alignItems='center'
                   sx={{flexGrow: 1}}>
              <Typography variant='h6'>
                Date:
              </Typography>
              <Typography
                variant='h6'>
                03/22/2025
              </Typography>
            </Stack>
            <Stack spacing={2}
                   display='flex'
                   direction='row'
                   justifyContent='space-between'
                   alignItems='center'
                   sx={{flexGrow: 1}}>
              <Typography variant='h6'>
                Amount:
              </Typography>
              <Typography
                variant='h6'>
                $55.00
              </Typography>
            </Stack>
            <Stack spacing={2}
                   display='flex'
                   direction='row'
                   justifyContent='space-between'
                   alignItems='center'
                   sx={{flexGrow: 1}}>
              <Typography variant='h6'>
                Status:
              </Typography>
              <Chip
                sx={{
                  px: "4px",
                  color: "#fff"
                }}
                size='small'
                label="Accepted"
                color={"success"}
              ></Chip>
            </Stack>
            <Divider/>
            <Stack spacing={2}
                   display='flex'
                   direction='row'
                   justifyContent='space-between'
                   alignItems='center'
                   sx={{flexGrow: 1}}>
              <Typography
                variant='h6'>
                Next payment
              </Typography>
            </Stack>
            <Stack spacing={2}
                   display='flex'
                   direction='row'
                   justifyContent='space-between'
                   alignItems='center'
                   sx={{flexGrow: 1}}>
              <Typography variant='h6'>
                Date:
              </Typography>
              <Typography
                variant='h6'>
                03/29/2025
              </Typography>
            </Stack>
            <Stack spacing={2}
                   display='flex'
                   direction='row'
                   justifyContent='space-between'
                   alignItems='center'
                   sx={{flexGrow: 1}}>
              <Typography variant='h6'>
                Amount:
              </Typography>
              <Typography
                variant='h6'>
                $55.00
              </Typography>
            </Stack>
            <Stack spacing={2}
                   display='flex'
                   direction='row'
                   justifyContent='space-between'
                   alignItems='center'
                   sx={{flexGrow: 1}}>
              <Typography variant='h6'>Status:</Typography>
              <Chip
                sx={{
                  px: "4px",
                  color: "#fff"
                }}
                size='small'
                label="Accepted"
                color={"success"}
              ></Chip>
            </Stack>
          </Stack>
        </Stack>
      </DashboardCard>
    ) : (
      <DashboardCard title='Negotiate To Pay Less'
                     action={
                       <Fab color='secondary' size='medium'
                            sx={{color: "#ffffff", cursor: "default"}}>
                         <TrendingDownIcon width={24}/>
                       </Fab>
                     }
      >
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant='h6'>
                </Typography>
              </TableCell>
              <TableCell align='center'>
                <Typography variant='h6'>
                  Date
                </Typography>
              </TableCell>
              <TableCell align='center'>
                <Typography variant='h6'>
                  Amount
                </Typography>
              </TableCell>
              <TableCell align='center'>
                <Typography variant='h6'>
                  Status
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography variant='h6'>
                  Previous payment
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant='h6'>
                  03/22/2025
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant='h6'>
                  $55.00 </Typography>
              </TableCell>
              <TableCell align="center">
                <Chip
                  sx={{
                    px: "4px",
                    color: "#fff"
                  }}
                  size='small'
                  label="Accepted"
                  color={"success"}
                ></Chip>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant='h6' padding={0}>
                  Next payment
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='h6' align='center'>
                  03/29/2025
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='h6' align='center'>
                  $55.00
                </Typography>
              </TableCell>
              <TableCell align='center'>
                <Chip
                  sx={{
                    px: "4px",
                    color: "#fff"
                  }}
                  size='small'
                  label="Accepted"
                  color={"success"}
                ></Chip>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </DashboardCard>
    )
  );
};

export default NegotiateToPayLessDetails;
